const menu = [
    {
      type: "PDF"
    },
    {
      type: "JPG"
    }
  ]

module.exports = menu;